module.exports = __webpack_public_path__ + "static/startup-india-435b88f013f867fd6c0d7a580d238eee.png";